import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import Main from "./pages/Main";
import Header from "./components/Header";
import ModalTemplate from "./components/ModalTemplate";

const App = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    console.log("v 1.0.0");
  }, []);

  return (
    <Box>
      <Header setIsModalOpen={setIsModalOpen} />
      <Main />
      <ModalTemplate
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </Box>
  );
};

export default App;
